import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import ScrollToTop from "./components/Common/ScrollToTop";
import ProtectedRoute from "./components/Auth/ProtectedRoute";

import Home from "./pages/home";
import About from "./pages/about";
import Team from "./pages/team";
import TeamDetails from "./pages/team-details";
import Testimonials from "./pages/testimonials";
import Pricing from "./pages/pricing";
import Faq from "./pages/faq";
import NoPage from "./pages/NoPage";
import Gallery from "./pages/gallery";
import GalleryDetails from "./pages/gallery-details";
import Events from "./pages/events";
import EventSingle from "./pages/event-single";
import Blog from "./pages/blog";
import Bloglist from "./pages/blog-list";
import BlogDetails from "./pages/blog-details";
import Contact from "./pages/contact";

// attendee auth + account (নতুন)
import Login from "./pages/login";
import Register from "./pages/register";
import MyBookings from "./pages/my-bookings";
import MyFavorites from "./pages/my-favorites";
import Payment from "./pages/payment";
import Ticket from "./pages/my-tickets";
import Notifications from "./pages/notifications";
import Profile from "./pages/profile";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteSettingsProvider>
        <ScrollToTop />
        <Routes>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="team" element={<Team />} />
          <Route path="team-details" element={<TeamDetails />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="gallery-details" element={<GalleryDetails />} />
          <Route path="faq" element={<Faq />} />
          <Route path="events" element={<Events />} />
          <Route path="events/:slug" element={<EventSingle />} />
          <Route path="blog" element={<Blog />} />
          <Route path="blog-list" element={<Bloglist />} />
          <Route path="blog-details" element={<BlogDetails />} />
          <Route path="blog-details/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<Contact />} />

          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />

          <Route
            path="my-bookings"
            element={
              <ProtectedRoute>
                <MyBookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="my-favorites"
            element={
              <ProtectedRoute>
                <MyFavorites />
              </ProtectedRoute>
            }
          />
          <Route
            path="payment/:reference"
            element={
              <ProtectedRoute>
                <Payment />
              </ProtectedRoute>
            }
          />
          <Route
            path="my-tickets/:reference"
            element={
              <ProtectedRoute>
                <Ticket />
              </ProtectedRoute>
            }
          />
          <Route
            path="notifications"
            element={
              <ProtectedRoute>
                <Notifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NoPage />} />
        </Routes>
      </SiteSettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
